import { PIcon } from '@porsche-design-system/components-react';

const CloseButton = () => <PIcon aria={{ 'aria-label': 'Chat icon' }} name="chat" />;

export default CloseButton;
